<template>
  <div
    class="checklist-progress flex h-5.5 shrink-0 flex-col justify-between"
    :class="currentProgress === checklistSize ? 'text-green' : 'text-accent'"
    :title="$t('ui.checklist_progress_title', { done: currentProgress, total: checklistSize })"
  >
    <div class="text-label font-bold leading-none whitespace-nowrap">
      {{ currentProgress }} / {{ checklistSize }}
    </div>
    <div class="relative h-0.75 w-full overflow-hidden rounded-full bg-current/25">
      <div
        class="absolute inset-y-0 left-0 min-w-1.25 max-w-full rounded-full bg-current"
        :style="{ width: `${(currentProgress / checklistSize) * 100}%` }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  checklist: {
    type: Array,
    required: true,
  },
});

const checklistSize = computed(() => props.checklist.length);
const currentProgress = computed(() => props.checklist.filter(c => c.state).length);
</script>
